module.exports = __webpack_public_path__ + "static/media/social-care.964b4333.svg";